import { type DependencyList, useEffect, useRef } from 'react';
import type { Subscription } from 'rxjs';

const useSubscriptions = (
  subscriptionsHandlers: () => Subscription[],
  deps?: DependencyList,
) => {
  const subscriptionsHandlersRef = useRef(subscriptionsHandlers);

  useEffect(() => {
    subscriptionsHandlersRef.current = subscriptionsHandlers;
  }, [subscriptionsHandlers]);

  useEffect(() => {
    const subscriptions = subscriptionsHandlersRef.current();
    return () => subscriptions.forEach(sub => sub.unsubscribe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps ?? []);
};

export default useSubscriptions;
